import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "crm:lg:hidden crm:fixed crm:bottom-0 crm:right-0 crm:m-4 crm:z-[1]" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue'
import {add} from '../svg/svgs.js'

export default {
  __name: 'ResponsiveActionButton',
  props: {
  /**
   * Definisce il tipo di azione da effettuare (utile per gestire il cambio icona)
   */
  actionType: {
    type: String,
    default: 'add'
  },
  /**
   * Definisce se visualizzare o meno le actions
   */
  showActions: {
    type: Boolean,
    default: false
  },
  /**
   * Definisce le possibili azioni da effettuare
   */
  actions: {
    type: Array,
    default: () => [{ name: '', description: '' }]
  }
},
  emits: ['clickActionButton', 'triggerAction'],
  setup(__props, { emit: __emit }) {

/**
 * @doc Responsive button for actions
 */
const props = __props
//</editor-fold>

//<editor-fold desc="Emits">
const emits = __emit
//</editor-fold>

//<editor-fold desc="Reactive">
const toggleActionsMenu = ref(false)
//</editor-fold>

//<editor-fold desc="Functions">
function checkActions() {
  emits('clickActionButton')
  if (props.showActions) toggleActionsMenu.value = !toggleActionsMenu.value
}
//</editor-fold>

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "crm:relative crm:p-4 crm:bg-primary crm:rounded-full",
      onClick: _withModifiers(checkActions, ["prevent"])
    }, [
      (__props.actionType === 'add')
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            "stroke-width": "2",
            sizing: {width:'22px', height: '16px'},
            stroke: "#ffffff",
            icon: _unref(add)
          }, null, 8 /* PROPS */, ["icon"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (toggleActionsMenu.value && __props.actions.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["crm:absolute crm:right-0 crm:w-[180px] crm:max-w-[180px] crm:rounded-sm crm:border crm:border-solid crm:border-neutral-300 crm:bg-white crm:text-black crm:shadow-lg", {
            'crm:-top-[50px] crm:h-[45px] crm:max-h-[45px]': __props.actions.length === 1,
            'crm:-top-[100px] crm:h-[90px] crm:max-h-[90px]': __props.actions.length === 2
          }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: action.name,
                    class: _normalizeClass(["crm:flex crm:justify-center crm:items-center crm:h-[45px] crm:max-h-[45px]", {
              'crm:border-solid crm:border-x-0 crm:border-t-0 crm:border-b crm:border-neutral-300':
                __props.actions.length >= 2 && index !== __props.actions.length - 1
            }]),
                    onClick: $event => (emits('triggerAction', action.name))
                  }, _toDisplayString(action.description), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

}